import type { ISbRichtext } from '@storyblok/svelte';

export const hasRichText = (text: ISbRichtext): boolean => {
	return Boolean(text?.content?.[0]?.content?.length || text?.content?.[0]?.attrs?.body?.length);
};
